// extracted by mini-css-extract-plugin
module.exports = {"conditionItem":"index_conditionItem__1zP_-","title":"index_title__iEdXb","condition":"index_condition__3UiPz","schoolName":"index_schoolName__12KoA"};